import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import {
  AuthenticationTokenGuard,
  CompanyGroupGuard,
  LocationTokenGuard,
  CompanyTokenNotExistGuard,
  UnAuthenticationTokenGuard,
  CompanyServiceEndedGuard,
  GuestCheckoutGuard,
} from '@symphony-solo/domain/authentication/src';
import { ServiceEndedGuard } from '@symphony-solo/domain/authentication/src/lib/guards/service-ended.gaurd';
import {
  ABOUT,
  ADD_CARD,
  CHECKOUT_ORDER,
  CHOOSE_LOCATION,
  CHOOSE_MENU,
  CUSTOMER_GROUPS,
  FAQ,
  LOCATION_SELECTION,
  LOGIN,
  LOYALTY,
  LOYALTY_POINTS,
  LOYALTY_VOUCHER,
  LOYALTY_VOUCHER_INTEROGATION,
  LOYALTY_WALLET,
  PAYMENTS,
  PAYMENT_CONFIRMATION,
  PAYMENT_SUCCESS,
  PRIVACY_POLICY,
  PURCHASE_HISTORY,
  RESET_PASSWORD,
  RESET_PASSWORD_CONFIRMATION,
  SELECT_APP_SIMPLE,
  SELECT_CARD,
  SIDE_MENU,
  SIGNUP,
  SIGNUP_CONFIRMATION,
  TABS,
  TERMS_AND_CONDITIONS,
  TRANSACTION_RECEIPT,
  CLICKCOLLECT_PURCHASE_HISTORY,
  LOYALTY_WALLET_INTERROGATION,
  ACCOUNT_DETAILS,
  PERSONAL_DETAILS,
  DEACTIVATE_ACCOUNT,
  CHANGE_PASSWORD,
  MY_CARDS,
  PAYMENT_CARDS,
  APP,
  ACCOUNT_SETTINGS_SURVAYS,
  ACCOUNT_SETTINGS_NOTIFICATIONS,
  ACCOUNT_SETTINGS_RECEIPTS,
  ACCOUNT_SETTINGS,
  ACCESSIBILITY_STATEMENT,
  CLICKCOLLECT_DETAILS,
  LOYALTY_CARDS,
  OTP,
  ALLERGEN_STATEMENT,
  NOT_FOUND,
  ENDED,
  PAGE_NOT_FOUND,
} from '@symphony-solo/shared/utils/src';

const routes: Routes = [
  { path: '', redirectTo: OTP, pathMatch: 'full' },
  {
    path: OTP,
    loadChildren: () => import('../../../otp/src/lib/pages-otp.module').then((m) => m.PagesOtpModule),
    canActivate: [CompanyGroupGuard],
  },
  {
    path: NOT_FOUND,
    loadChildren: () =>
      import('../../../company-not-found/src/lib/pages-company-not-found.module').then((m) => m.PagesCompanyNotFoundModule),
    canActivate: [ServiceEndedGuard],
  },
  {
    path: PAGE_NOT_FOUND,
    loadChildren: () => import('../../../page-not-found/src/lib/pages-page-not-found.module').then((m) => m.PagesPageNotFoundModule),
    canActivate: [],
  },
  {
    path: ENDED,
    loadChildren: () => import('../../../ended/src/lib/pages-ended.module').then((m) => m.PagesEndedModule),
    canActivate: [CompanyServiceEndedGuard],
  },
  {
    path: LOGIN,
    loadChildren: () => import('../../../login/src/lib/pages-login.module').then((m) => m.PagesLoginModule),
    canActivate: [CompanyTokenNotExistGuard, ServiceEndedGuard],
  },
  {
    path: SIGNUP,
    loadChildren: () => import('../../../signup/src/lib/pages-signup.module').then((m) => m.PagesSignupModule),
    canActivate: [UnAuthenticationTokenGuard, ServiceEndedGuard],
  },
  {
    path: SIGNUP_CONFIRMATION,
    loadChildren: () =>
      import('../../../signup/src/lib/signup-confirmation/signup-confirmation.module').then((m) => m.SignupConfirmationModule),
    canActivate: [ServiceEndedGuard],
  },
  {
    path: RESET_PASSWORD,
    loadChildren: () => import('../../../reset-password/src/lib/pages-reset-password.module').then((m) => m.PagesResetPasswordModule),
    canActivate: [UnAuthenticationTokenGuard, ServiceEndedGuard],
  },
  {
    path: RESET_PASSWORD_CONFIRMATION,
    loadChildren: () =>
      import('../../../reset-password-confirmation/src/lib/pages-reset-password-confirmation.module').then(
        (m) => m.PagesResetPasswordConfirmationModule
      ),
    canActivate: [UnAuthenticationTokenGuard, ServiceEndedGuard],
  },
  {
    path: SELECT_APP_SIMPLE,
    pathMatch: 'full',
    loadChildren: () => import('../../../select-app/src/lib/pages-select-app.module').then((m) => m.PagesSelectAppModule),
    canActivate: [ServiceEndedGuard],
  },
  {
    path: LOYALTY_POINTS,
    pathMatch: 'full',
    loadChildren: () => import('../../../loyalty/points/src/lib/pages-loyalty-points.module').then((m) => m.PagesLoyaltyPointsModule),
    canActivate: [AuthenticationTokenGuard, ServiceEndedGuard],
  },
  {
    path: LOYALTY_WALLET,
    pathMatch: 'full',
    loadChildren: () => import('../../../loyalty/wallet/src/lib/pages-loyalty-wallet.module').then((m) => m.PagesLoyaltyWalletModule),
    canActivate: [AuthenticationTokenGuard, ServiceEndedGuard],
  },
  {
    path: LOYALTY_VOUCHER,
    pathMatch: 'full',
    loadChildren: () => import('../../../loyalty/voucher/src/lib/pages-loyalty-voucher.module').then((m) => m.PagesLoyaltyVoucherModule),
    canActivate: [AuthenticationTokenGuard, ServiceEndedGuard],
  },
  {
    path: LOYALTY_VOUCHER_INTEROGATION,
    pathMatch: 'full',
    loadChildren: () =>
      import('../../../loyalty/voucher-interogate/src/lib/pages-loyalty-voucher-interogate.module').then(
        (m) => m.PagesLoyaltyVoucherInterogateModule
      ),
    canActivate: [AuthenticationTokenGuard, ServiceEndedGuard],
  },
  {
    path: LOYALTY_WALLET_INTERROGATION,
    pathMatch: 'full',
    loadChildren: () =>
      import('../../../loyalty/wallet-interrogate/src/lib/pages-loyalty-wallet-interrogate.module').then(
        (m) => m.PagesLoyaltyWalletInterrogateModule
      ),
    canActivate: [AuthenticationTokenGuard, ServiceEndedGuard],
  },
  {
    path: ACCOUNT_SETTINGS,
    pathMatch: 'full',
    loadChildren: () => import('../../../account-settings/src/lib/pages-account-settings.module').then((m) => m.PagesAccountSettingsModule),
    canActivate: [AuthenticationTokenGuard, ServiceEndedGuard],
  },
  {
    path: ACCOUNT_SETTINGS_SURVAYS,
    pathMatch: 'full',
    loadChildren: () => import('../../../account-settings/src/lib/surveys/src/lib/pages-surveys.module').then((m) => m.PagesSurveysModule),
    canActivate: [AuthenticationTokenGuard, ServiceEndedGuard],
  },
  {
    path: ACCOUNT_SETTINGS_NOTIFICATIONS,
    pathMatch: 'full',
    loadChildren: () =>
      import('../../../account-settings/src/lib/notifications/src/lib/pages-notifications.module').then((m) => m.PagesNotificationsModule),
    canActivate: [AuthenticationTokenGuard, ServiceEndedGuard],
  },
  {
    path: ACCOUNT_SETTINGS_RECEIPTS,
    pathMatch: 'full',
    loadChildren: () =>
      import('../../../account-settings/src/lib/receipts/src/lib/pages-receipts.module').then((m) => m.PagesReceiptsModule),
    canActivate: [AuthenticationTokenGuard, ServiceEndedGuard],
  },
  {
    path: ACCOUNT_DETAILS,
    pathMatch: 'full',
    loadChildren: () => import('../../../account/src/lib/pages-account.module').then((m) => m.PagesAccountModule),
    canActivate: [AuthenticationTokenGuard, ServiceEndedGuard],
  },
  {
    path: PERSONAL_DETAILS,
    pathMatch: 'full',
    loadChildren: () =>
      import('../../../account/src/lib/personal-details/src/lib/pages-personal-details.module').then((m) => m.PagesPersonalDetailsModule),
    canActivate: [AuthenticationTokenGuard, ServiceEndedGuard],
  },
  {
    path: CHANGE_PASSWORD,
    pathMatch: 'full',
    loadChildren: () =>
      import('../../../account/src/lib/change-password/src/lib/pages-change-password.module').then((m) => m.PagesChangePasswordModule),
    canActivate: [AuthenticationTokenGuard, ServiceEndedGuard],
  },
  {
    path: CHOOSE_LOCATION,
    loadChildren: () =>
      import('../../../select-app/src/lib/choose-location-page/choose-location-page.module').then((m) => m.ChooseLocationPageModule),
    canActivate: [ServiceEndedGuard],
  },
  {
    path: DEACTIVATE_ACCOUNT,
    pathMatch: 'full',
    loadChildren: () =>
      import('../../../account/src/lib/deativate-account/src/lib/pages-deativate-account.module').then(
        (m) => m.PagesDeactivateAccountModule
      ),
    canActivate: [AuthenticationTokenGuard, ServiceEndedGuard],
  },
  {
    path: CHOOSE_MENU,
    loadChildren: () =>
      import('../../../select-app/src/lib/choose-location-page/choose-menu-page/choose-menu-page.module').then(
        (m) => m.ChooseMenuPageModule
      ),
    canActivate: [ServiceEndedGuard],
  },
  {
    path: CHECKOUT_ORDER,
    loadChildren: () =>
      import('../../../select-app/src/lib/choose-location-page/checkout-page/checkout-page.module').then((m) => m.CheckoutPageModule),
    canActivate: [GuestCheckoutGuard, ServiceEndedGuard],
  },
  {
    path: PAYMENT_SUCCESS,
    loadChildren: () =>
      import('../../../select-app/src/lib/choose-location-page/payment-success-page/payment-success-page.module').then(
        (m) => m.PaymentSuccessPageModule
      ),
    canActivate: [ServiceEndedGuard],
  },
  {
    path: APP,
    loadChildren: () =>
      import('../../../tabs-navigation-cc/src/lib/pages-tabs-navigation-cc.module').then((m) => m.PagesTabsNavigationModule),
    // canActivate: [AnonymousUserGuard],
  },
  {
    path: TABS,
    loadChildren: () => import('../../../tabs-navigation/src/lib/pages-tabs-navigation.module').then((m) => m.PagesTabsNavigationModule),
    canActivate: [LocationTokenGuard],
  },
  {
    path: LOCATION_SELECTION,
    loadChildren: () =>
      import('../../../location-selection/src/lib/pages-location-selection.module').then((m) => m.PagesLocationSelectionModule),
    canActivate: [LocationTokenGuard, ServiceEndedGuard],
  },
  {
    path: PAYMENT_CONFIRMATION,
    loadChildren: () =>
      import('../../../payment-confirmation/src/lib/pages-payment-confirmation.module').then((m) => m.PagesPaymentConfirmationModule),
    canActivate: [LocationTokenGuard, ServiceEndedGuard],
  },
  {
    path: SIDE_MENU,
    loadChildren: () => import('../../../side-menu/src/lib/pages-side-menu.module').then((m) => m.PagesSideMenuModule),
    canActivate: [AuthenticationTokenGuard, ServiceEndedGuard],
  },
  {
    path: PURCHASE_HISTORY,
    pathMatch: 'full',
    loadChildren: () => import('../../../purchase-history/src/lib/pages-purchase-history.module').then((m) => m.PagesPurchaseHistoryModule),
    canActivate: [AuthenticationTokenGuard, ServiceEndedGuard],
  },
  {
    path: CLICKCOLLECT_PURCHASE_HISTORY,
    pathMatch: 'full',
    loadChildren: () =>
      import('../../../clickcollect-purchase-history/src/lib/pages-clickcollect-purchase-history.module').then(
        (m) => m.PagesClickCollectPurchaseHistoryModule
      ),
    canActivate: [AuthenticationTokenGuard, ServiceEndedGuard],
  },
  {
    path: CLICKCOLLECT_DETAILS,
    pathMatch: 'full',
    loadChildren: () =>
      import('../../../clickcollect-purchase-history/src/lib/clickcollect-details/src/lib/pages-clickcollect-details.module').then(
        (m) => m.PagesClickCollectDetailsModule
      ),
    canActivate: [AuthenticationTokenGuard, ServiceEndedGuard],
  },
  {
    path: ADD_CARD,
    loadChildren: () => import('../../../add-card/src/lib/pages-add-card.module').then((m) => m.PagesAddCardModule),
    canActivate: [LocationTokenGuard, ServiceEndedGuard],
  },
  {
    path: MY_CARDS,
    loadChildren: () => import('../../../my-cards/src/lib/pages-my-cards.module').then((m) => m.PagesMyCardsModule),
    canActivate: [AuthenticationTokenGuard, ServiceEndedGuard],
  },
  {
    path: PAYMENT_CARDS,
    loadChildren: () => import('../../../my-cards/src/lib/payment-cards-page/payment-cards.module').then((m) => m.PaymentCardsPageModule),
    canActivate: [AuthenticationTokenGuard, ServiceEndedGuard],
  },
  {
    path: LOYALTY_CARDS,
    loadChildren: () => import('../../../my-cards/src/lib/loyalty-cards-page/loyalty-cards.module').then((m) => m.LoyaltyCardsPageModule),
    canActivate: [AuthenticationTokenGuard, ServiceEndedGuard],
  },
  {
    path: CUSTOMER_GROUPS,
    loadChildren: () => import('../../../customer-group/src/lib/pages-customer-group.module').then((m) => m.PagesCustomerGroupModule),
    canActivate: [LocationTokenGuard, ServiceEndedGuard],
  },
  {
    path: SELECT_CARD,
    loadChildren: () => import('../../../select-card/src/lib/pages-select-card.module').then((m) => m.PagesSelectCardModule),
    canActivate: [LocationTokenGuard, ServiceEndedGuard],
  },
  {
    path: TERMS_AND_CONDITIONS,
    loadChildren: () =>
      import('../../../terms-and-conditions/src/lib/pages-terms-and-conditions.module').then((m) => m.PagesTermsAndConditionsModule),
    canActivate: [ServiceEndedGuard],
  },
  {
    path: PAYMENTS,
    loadChildren: () => import('../../../payment/src/lib/pages-payment.module').then((m) => m.PagesPaymentModule),
    canActivate: [LocationTokenGuard, ServiceEndedGuard],
  },
  {
    path: TRANSACTION_RECEIPT,
    pathMatch: 'full',
    loadChildren: () =>
      import('../../../transaction-receipt/src/lib/pages-transaction-receipt.module').then((m) => m.PagesTransactionReceiptModule),
    canActivate: [ServiceEndedGuard],
  },
  {
    path: LOYALTY,
    loadChildren: () =>
      import('../../../loyalty/tabs-navigation/src/lib/pages-loyalty-tabs-navigation.module').then(
        (m) => m.PagesLoyaltyTabsNavigationModule
      ),
    canActivate: [AuthenticationTokenGuard, ServiceEndedGuard],
  },
  {
    path: ABOUT,
    loadChildren: () => import('../../../about/src/lib/pages-about.module').then((m) => m.PagesAboutModule),
    canActivate: [ServiceEndedGuard],
  },
  {
    path: FAQ,
    loadChildren: () => import('../../../faq/src/lib/pages-faq.module').then((m) => m.PagesFaqModule),
    canActivate: [ServiceEndedGuard],
  },
  {
    path: ACCESSIBILITY_STATEMENT,
    loadChildren: () =>
      import('../../../accessibility-statement/src/lib/pages-accessibility-statement.module').then(
        (m) => m.PagesAccessibilityStatementModule
      ),
    canActivate: [ServiceEndedGuard],
  },
  {
    path: ALLERGEN_STATEMENT,
    loadChildren: () =>
      import('../../../allergen-statement/src/lib/pages-allergen-statement.module').then((m) => m.PagesAllergenStatementModule),
    canActivate: [ServiceEndedGuard],
  },
  {
    path: PRIVACY_POLICY,
    loadChildren: () => import('../../../privacy-policy/src/lib/pages-privacy-policy.module').then((m) => m.PagesPrivacyPolicyModule),
    canActivate: [ServiceEndedGuard],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
  exports: [RouterModule],
})
export class PagesRoutingSharedModule {}
